import { IApplicationState } from '../../types/redux';
import { getDeveloperRatingById } from './getDeveloperRatingById';

export function getDeveloperRatingLegendById(state: IApplicationState, id: number) {
  const rating = getDeveloperRatingById(state, id);

  return rating?.graph.data || [];
}
